/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { Button } from '@mairistem/composants';

import ModalGestionTrimestreRow from './ModalGestionTrimestreRow';

// @ts-expect-error
import iconGeneration from '../../../../assets/images/generation.png';

interface ModalGestionTrimestreRowGenerationProps {
  numerotation: Date;
  generation: Date;
  loading: boolean;
  onGeneration: () => void;
  onTelechargement: () => void;
  isClotured?: boolean;
}

const ModalGestionTrimestreRowGeneration = (
  props: ModalGestionTrimestreRowGenerationProps,
) => {
  const {
    numerotation,
    generation,
    loading,
    onGeneration,
    onTelechargement,
    isClotured = false,
  } = props;

  const [generationLoading, setGenerationLoading] =
    React.useState<boolean>(false);
  const [telechargementLoading, setTelechargementLoading] =
    React.useState<boolean>(false);

  React.useEffect(() => {
    if (!loading) {
      setGenerationLoading(false);
      setTelechargementLoading(false);
    }
  }, [loading]);

  const handleGeneration = React.useCallback(() => {
    setGenerationLoading(true);
    onGeneration();
  }, [onGeneration]);

  const handleTelechargement = React.useCallback(() => {
    setTelechargementLoading(true);
    onTelechargement();
  }, [onTelechargement]);

  const content = React.useMemo(
    () => (
      <>
        <h3>Génération du fichier Pecoto+</h3>
        <p>
          Génération de la liste dématérialisée des recensés à transférer au
          Bureau / Centre du Service National.
        </p>
        {generation ? (
          <p>
            <i>
              Fichier généré le
              {` ${generation.toLocaleDateString()}`}
            </i>
          </p>
        ) : (
          <p>
            <i>Génération du fichier Pecoto+ non effectuée</i>
          </p>
        )}
      </>
    ),
    [generation],
  );

  const actions = React.useMemo(
    () => (
      <>
        <Button
          data-testid="modal-gestion-trimestre-bouton-generation"
          content="Générer"
          {...(!_.isNil(numerotation) && !generation && { color: 'blue' })}
          onClick={handleGeneration}
          loading={generationLoading}
          style={{ width: 130 }}
          disabled={
            !_.isNil(generation) || !numerotation || loading || isClotured
          }
        />
        <Button
          data-testid="modal-gestion-trimestre-bouton-telecharger"
          content="Télécharger"
          color="blue"
          onClick={handleTelechargement}
          loading={telechargementLoading}
          style={{ width: 130 }}
          disabled={_.isNil(generation) || loading}
        />
      </>
    ),
    [
      loading,
      generation,
      numerotation,
      generationLoading,
      telechargementLoading,
      handleGeneration,
      handleTelechargement,
      isClotured,
    ],
  );

  return (
    <ModalGestionTrimestreRow
      icon={iconGeneration}
      content={content}
      actions={actions}
    />
  );
};

export default ModalGestionTrimestreRowGeneration;
